var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"toogle",on:{"click":_vm.onChange}},[_c('i',{directives:[{name:"show",rawName:"v-show",value:(_vm.value),expression:"value"}],staticClass:"fa fa-fw fa-toggle-on"}),_c('i',{directives:[{name:"show",rawName:"v-show",value:(!_vm.value),expression:"!value"}],staticClass:"fa fa-fw fa-toggle-off"})])
}
var staticRenderFns = []

export { render, staticRenderFns }